import * as $ from 'jquery';
import 'bootstrap';
import {bookingFormCommon} from './c005-bookingform-common';

export class nfsForm{
	private $viewBookingError:Array<string> = [];
	private bcommon = new bookingFormCommon();
	private $newsletterError:Array<string> = [];
	private pg_apiKey:any = $("#view-nfs--container").attr("data-nfs-apikey"); 

	$scope: any = $('#view-nfs--container');
	$scopeMob: any = $('#mob-nfs--container');

	viewNfsForm(): void {
		let _self = this;
		let bcommon = _self.bcommon;
		let scriptUrl:any = $("#view-nfs--container").attr("data-nfs-scripturl"); 


        // let scriptEl:any = document.createElement('script');
        // scriptEl.src = scriptUrl;
        // scriptEl.async = true;
        // scriptEl.type = "text/javascript";
        // document.getElementsByTagName('body')[0].appendChild(scriptEl);

		let $vbErrorValidation: any = _self.$scope.find('.viewbooking-error--validation');
		let $vbValidator : any = _self.$scope.find('.viewbooking-validator');
		let $vbSubmitBtn: any = _self.$scope.find('.viewBooking');
		let $vbRefNo: any = _self.$scope.find('.view-booking--refno');
		let $vbLastName: any = _self.$scope.find('.view-booking--lastname');
		let $refnoticketnumber:any=_self.$scope.find(".refnoticketnumber-validator");
		let refnoticketnumberVal = $('#view-booking--checkInPnr').val().trim();

		let $mobVBErrorValidation: any = _self.$scopeMob.find('.viewbooking-error--validation');
		let $mobVBValidator : any = _self.$scopeMob.find('.viewbooking-validator');
		let $mobVBSubmitBtn: any = _self.$scopeMob.find('.viewBooking');
		let $mobVBRefNo: any = _self.$scopeMob.find('.view-booking--refno');
		let $mobVBLastName: any = _self.$scopeMob.find('.view-booking--lastname');
		let $mobrefnoticketnumber:any=_self.$scope.find(".refnoticketnumber-validator");
		let ticketNoLimits = [6,14];
		let numberPattern = /^\d+$/;
		let eticketNumberPattern = /^\d{3}-\d{10}$/;
		/** desktop nfs booking submit handler */
		$vbSubmitBtn.click((evt:any) => {
			evt.preventDefault();
			let $validationSuccess    : any = true;
			_self.$viewBookingError = [];
			$vbErrorValidation.show();
		let refnoticketnumberVal = $('#view-booking--checkInPnr').val().trim();

			/** validate PNR. */
			if($vbRefNo.val() == ''){
				let $vbRefNoValidate:any = $vbRefNo.attr('data-eticketno');
				_self.$viewBookingError.push('<strong>'+$vbRefNo.parent().find('label').text()+':</strong> '+$vbRefNoValidate);
				$vbRefNo.addClass('has-error');
				$vbRefNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$vbRefNo.removeClass('has-error');
				$vbRefNo.parent().find('.booking-form--title').removeClass('has-error');
			}
			/** validate booking No */
			if($refnoticketnumber.val() == ''){
				let $vbRefNoValidate:any = $refnoticketnumber.attr('data-eticketnolen');
				_self.$viewBookingError.push('<strong>'+$refnoticketnumber.parent().find('label').text()+':</strong> '+$vbRefNoValidate);
				$refnoticketnumber.addClass('has-error');
				$refnoticketnumber.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			}
			else if (
					!ticketNoLimits.includes(refnoticketnumberVal.length) 
						|| (refnoticketnumberVal.length == 14 && !eticketNumberPattern.test(refnoticketnumberVal))
						|| (refnoticketnumberVal.length == 6 && numberPattern.test(refnoticketnumberVal))
				){
				let $vbRefNoValidate:any = $refnoticketnumber.attr('data-eticket');
				_self.$viewBookingError.push('<strong>'+$refnoticketnumber.parent().find('label').text()+':</strong> '+$vbRefNoValidate);
				$refnoticketnumber.addClass('has-error');
				$refnoticketnumber.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;			
			}
			 else{
				$refnoticketnumber.removeClass('has-error');
				$refnoticketnumber.parent().find('.booking-form--title').removeClass('has-error');
			}
			/** validate Last Name */
			if($vbLastName.val() == ''){
				let $vbLastNameValidate:any = $vbLastName.attr('data-lastname');
				_self.$viewBookingError.push('<strong>'+$vbLastName.parent().find('label').text()+':</strong> '+$vbLastNameValidate);
				$vbLastName.addClass('has-error');
				$vbLastName.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$vbLastName.removeClass('has-error');
				$vbLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $vbValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=_self.$viewBookingError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$viewBookingError[i] + '</li>');
			}

			if($validationSuccess) {
				$vbErrorValidation.hide();
				bcommon.preloader();
		
				var callback = function (response) {
					if (response.eligible) {
						window.location.href = response.offerUrl;
					}
					else {
						_self.$viewBookingError.push('<strong> Error: </strong> '+response.message);
						for (var i=0, len=_self.$viewBookingError.length; i<len; i++) {
							$validationMessagelist.append('<li data-id="'+i+'">' + _self.$viewBookingError[i] + '</li>');
						}
						$vbErrorValidation.show();
						bcommon.preloaderClose();
					}
				};
				$.getScript(scriptUrl)
					.done(function() {
						var setIntervalID = setInterval(function() {
							clearInterval(setIntervalID);
							plusgrade.lookup(_self.pg_apiKey,$refnoticketnumber.val(), $vbLastName.val(), callback);
						}, 1000);
					});
				
			}
		});

		/** Mobile -  manage booking submit handler */
		$mobVBSubmitBtn.click((evt:any) => {
			evt.preventDefault();
			let $validationSuccess    : any = true;
			_self.$viewBookingError = [];
			$mobVBErrorValidation.show();
		let refnoticketnumberValmob = $('#mob-view-booking--checkInPnr').val().trim();
			/** validate View Booking Ref No. */
			if($mobVBRefNo.val() == ''){
				let $mobVbRefNoValidate:any = $mobVBRefNo.attr('data-eticketlen');
				_self.$viewBookingError.push('<strong>'+$mobVBRefNo.parent().find('label').text()+':</strong> '+$mobVbRefNoValidate);
				$mobVBRefNo.addClass('has-error');
				$mobVBRefNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			}	else if (
					!ticketNoLimits.includes(refnoticketnumberValmob.length) 
						|| (refnoticketnumberValmob.length == 14 && !eticketNumberPattern.test(refnoticketnumberValmob))
						|| (refnoticketnumberValmob.length == 6 && numberPattern.test(refnoticketnumberValmob))
				){
				let $vbRefNoValidate:any = $refnoticketnumber.attr('data-eticket');
				_self.$viewBookingError.push('<strong>'+$refnoticketnumber.parent().find('label').text()+':</strong> '+$vbRefNoValidate);
				$mobVBRefNo.addClass('has-error');
				$mobVBRefNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;			
			} 
			else{
				$mobVBRefNo.removeClass('has-error');
				$mobVBRefNo.parent().find('.booking-form--title').removeClass('has-error');
			}
			/** validate Last Name */
			if($mobVBLastName.val() == ''){
				let $mobVBLastNameValidate:any = $mobVBLastName.attr('data-lastname');
				_self.$viewBookingError.push('<strong>'+$mobVBLastName.parent().find('label').text()+':</strong> '+$mobVBLastNameValidate);
				$mobVBLastName.addClass('has-error');
				$mobVBLastName.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$mobVBLastName.removeClass('has-error');
				$mobVBLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $mobVBValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$viewBookingError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$viewBookingError[i] + '</li>');
			}

			if($validationSuccess) {
				$mobVBErrorValidation.hide();
				bcommon.preloader();
				var callback = function (response) {
					if (response.eligible) {
						window.location.href = response.offerUrl;
					}
					else {
						_self.$viewBookingError.push('<strong> Error: </strong> '+response.message);
						for (var i=0, len=_self.$viewBookingError.length; i<len; i++) {
							$validationMessagelist.append('<li data-id="'+i+'">' + _self.$viewBookingError[i] + '</li>');
						}
						$mobVBErrorValidation.show();
						bcommon.preloaderClose();
					}
				};
				$.getScript(scriptUrl)
				.done(function() {
					var setIntervalID = setInterval(function() {
						clearInterval(setIntervalID);
						plusgrade.lookup(_self.pg_apiKey,$mobVBRefNo.val(), $mobVBLastName.val(), callback);
					}, 1000);
				});
			
			}
		});

		
	}
	nfsComponentForm(): void {
		let _self = this;
		let bcommon = _self.bcommon;
		let $nfsCmpValidator: any = $('#PlusgradeNfs-validator');
		let $nfsCmpPnr: any = $('#PlusgradeNfsEmail');
		let $nfsCmpLastName: any = $('#PlusgradeNfsLastName');
		let $nfsCmpSubmit: any = $('#PlusgradeNfsSubmit');
		let $nfsCmpErrorValidation: any = $('.PlusgradeNfs-error--validation');
		if (_self.$scope.length == 0) { return; }

		$nfsCmpSubmit.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			let $validationSuccess = true;
			_self.$newsletterError = [];
			$nfsCmpErrorValidation.show();

			let $nfsCmpPnrVal       = $nfsCmpPnr.val();
			let $nfsCmpLastNameVal  = $nfsCmpLastName.val();
			let scriptUrl:any = $("#view-nfs--container").attr("data-nfs-scripturl"); 
			if ($nfsCmpPnrVal== ''){
				$validationSuccess = false;
				let $newsletterEmailValidate:any = $nfsCmpPnr.attr('data-pnr');
				_self.$newsletterError.push('<strong>'+$nfsCmpPnr.parent().find('.booking-form--title').text()+':</strong> '+$newsletterEmailValidate);
				$nfsCmpPnr.addClass('has-error');
				$nfsCmpPnr.parent().find('.booking-form--title').addClass('has-error');
			} else {
				$nfsCmpPnr.removeClass('has-error');
				$nfsCmpPnr.parent().find('.booking-form--title').removeClass('has-error');
			}

			if ($nfsCmpLastNameVal == ''){
				$validationSuccess = false;
				$nfsCmpLastName.addClass('has-error');
				$nfsCmpLastName.parent().find('.booking-form--title').addClass('has-error');
				let $preferredCityValidate:any = $nfsCmpLastName.attr('data-lastName');
				_self.$newsletterError.push('<strong>'+$nfsCmpLastName.parent().find('.booking-form--title').text()+':</strong> '+$preferredCityValidate);
			} else {
				$nfsCmpLastName.removeClass('has-error');
				$nfsCmpLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $nfsCmpValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=_self.$newsletterError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + _self.$newsletterError[i] + '</li>');
			}

			if($validationSuccess == true){
				bcommon.preloader();
				$nfsCmpErrorValidation.show();

				var callback = function (response) {

					if (response.eligible) {
						window.location.href = response.offerUrl;
					}
					else {
						_self.$newsletterError.push('<strong> Error: </strong> '+response.message);
						for (var i=0, len=_self.$newsletterError.length; i<len; i++) {
							$validationMessagelist.append('<li data-id="'+i+'">' + _self.$newsletterError[i] + '</li>');
						}
						$nfsCmpErrorValidation.show();
						bcommon.preloaderClose();
					}
				};
				$.getScript(scriptUrl)
				.done(function() {
					var setIntervalID = setInterval(function() {
						clearInterval(setIntervalID);
						plusgrade.lookup(_self.pg_apiKey,$nfsCmpPnrVal, $nfsCmpLastNameVal, callback);
					}, 1000);
				});
							}
		});


	}
  /**
	 * validate both input fields in form for empty state
	 *
	 * if both not empty, hide error message div
	 * else do nothing
	 * @param {any} valEl    [error messages div]
	 * @param {any} refNo    [booking reference input]
	 * @param {any} lastName [last name input]
	 */
	validateEmptyInput(valEl:any, refNo:any, lastName:any): boolean {
  	let _self = this;
		if (refNo.val() != '' && lastName.val() != '') {
			valEl.hide();
			return false;
		}
		else {
			return true;
		}
	}

  /**
   * validate booking reference no
   *
   * if error found:
   * - add 'has-error' class to input and label
   * - append error message to error array obj
   * else:
   * - remove 'has-error' class from input and label
   * @param {any} refNo [booking reference input]
   */
  validateRefNo(refNo:any): boolean {
  	let _self = this;
  	if (refNo.val() == '') {
  		refNo.addClass('has-error');
  		refNo.parent().find('.booking-form--title').addClass('has-error');
  		var validateTicket = refNo.attr('data-eticketno');
  		_self.$viewBookingError.push(validateTicket);
  		return false;
  	}
  	else {
  		refNo.removeClass('has-error');
  		refNo.parent().find('.booking-form--title').removeClass('has-error');
  		return true;
  	}
  }
  validateRefenNo(): void {
	let alphaNumericPattern = /^([a-zA-Z0-9_]+)$/;
		$('.name-validator').off('keydown').on('keydown', function (e: any) {
			// Allow: backspace, delete, tab, escape, enter
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
				// Allow: Ctrl/cmd+A
				(e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+C
				(e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+X
				(e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				// let it happen, don't do anything
					return;
			}
			// Ensure that it is a number and stop the keypress
			let arr: any = [8,16,17,20,32,35,36,37,38,39,40,45,46];
			for(let i = 65; i <= 90; i++){
				arr.push(i);
			}
			if ($.inArray(e.which, arr) === -1) {
				event.preventDefault();
			}
		});

		$('.alphanum-validator').off('keyup').on('keyup',function (e:any) {
			if (this.value.match(/[^a-zA-Z0-9 ]/g)) {
				this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
			}
		});

		$('.refnoticketnumber-validator').off('keyup').on('keyup',function (e:any) {

			if (this.value.length < 7) {
				if (alphaNumericPattern.test(this.value.replace('-', '')) && isNaN(this.value.replace('-', ''))) {
					this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
				}
			} else if (this.value.length > 6 && e.keyCode != 37 && e.keyCode != 39) {
				if (isNaN(this.value.replace('-', ''))) {
					this.value = this.value.substring(0, 6);
				} else if (!isNaN(this.value.replace('-', ''))) {
					this.value = this.value.replace(/[^0-9 ]/g, '');
					this.value = this.value.replace(/./g, function(v, i) {
						return i === 2 ? v + "-" : v;
					});
				}
			}
		});

		$('.num-validator').off('keydown').on('keydown', function(e: any) {
			-1 !== $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) || /65|67|86|88/.test(e.keyCode) && (!0 === e.ctrlKey || !0 === e.metaKey) || 35 <= e.keyCode && 40 >= e.keyCode || (e.shiftKey || 48 > e.keyCode || 57 < e.keyCode) && (96 > e.keyCode || 105 < e.keyCode) && e.preventDefault()
		});
  }
  /**
   * validate last name
   *
   * if error found:
   * - add 'has-error' class to input and label
   * - append error message to error array obj
   * else:
   * - remove 'has-error' class from input and label
   * @param {any} refNo [last name input]
   */
  validateLastName(lastName:any): boolean {
  	let _self = this;
  	if (lastName.val() == '') {
  		lastName.addClass('has-error');
  		lastName.parent().find('.booking-form--title').addClass('has-error');
  		var validateLastName_1 = lastName.attr('data-lastname');
  		_self.$viewBookingError.push(validateLastName_1);
  		return false;
  	}
  	else {
  		lastName.removeClass('has-error');
  		lastName.parent().find('.booking-form--title').removeClass('has-error');
  		return true;
  	}
  }

  /**
   * consolidate error messages in error array obj to string
   * and print to error message element
   * @param {any} errorEl [error message element]
   */
  errConsolidate(errorEl:any): void {
  	let _self = this;
  	errorEl.text(_self.$viewBookingError.join(', '));
  	return;
  }



}

let scope:Element = document.querySelector('#view-nfs--container');
if (scope){
	try {
		let nfsForms = new nfsForm();
		nfsForms.viewNfsForm();
		nfsForms.nfsComponentForm();
		nfsForms.validateRefenNo();
	} catch(e) {console.error(e);}
}